import { BaseRequest } from './BaseRequest';

export class BotHealthWebhookRequest extends BaseRequest {
    WabaId: string;
}